import React from "react";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";

const DragDrop = ({children, reorder}) => {
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const startIndex = result.source.index;
        const endIndex = result.destination.index;

        reorder && reorder(startIndex, endIndex);
    }

    return <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">

            {(provided, snapshot) => {
                return <div ref={provided.innerRef}
                    style={{display: 'flex', flexDirection: 'column'}}
                    {...provided.droppableProps}
                >
                    {children}
                    {provided.placeholder}
                </div>
            }}

        </Droppable>
    </DragDropContext>
}
/*
const DraggableItem = ({children, id, index, className, draggingClassNames}) => {
        return <Draggable draggableId={id} index={index}>
            {(provided, snapshot) => <div ref={provided.innerRef}
                className={classNames(className, snapshot.isDragging && draggingClassNames)}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >{child}</div>}
        </Draggable>
    })}
}
 */

export default DragDrop;